import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import { lineTotal, cartTotal, formatMoney } from './cart'

const useStyles = makeStyles((theme) => ({
  listItem: { padding: theme.spacing(1, 0) },
  total: { fontWeight: 700 },
  terms: { marginTop: theme.spacing(2) },
}))

/**
 * What the payer is about to buy.
 *
 * Read-only by design: no inputs, no state, nothing that can disagree with the snapshot.
 * The list shape is the one ReviewDoc.js has carried commented out since it was written.
 *
 * Every figure is recomputed from the lines rather than taken from `jsond_doc.total`. The
 * two should always agree — the server builds the total the same way — and showing a payer a
 * total that does not add up to the lines above it is worse than showing either alone.
 */
export default function ReviewCart({ data }) {
  const classes = useStyles()
  const { t } = useTranslation()

  const snapshot = data.jsond_doc
  const lines = snapshot.lines || []
  const currency = snapshot.currency_id

  return (
    <React.Fragment>
      <List disablePadding>
        {lines.map((line, i) => (
          <ListItem className={classes.listItem} key={i}>
            <ListItemText primary={line.name} secondary={line.description} />
            <Typography variant="body2">
              {line.qty} × {formatMoney(line.price, currency)} = {formatMoney(lineTotal(line), currency)}
            </Typography>
          </ListItem>
        ))}
        <ListItem className={classes.listItem}>
          <ListItemText primary={t('Total')} />
          <Typography variant="subtitle1" className={classes.total}>
            {formatMoney(cartTotal(lines), currency)}
          </Typography>
        </ListItem>
      </List>

      {/* The merchant's own small print — a link to terms, a refund note. Rendered only when
          the snapshot carries one, so an unset setting shows nothing rather than an empty box. */}
      {snapshot.terms ? (
        <Typography variant="body2" color="textSecondary" className={classes.terms}>
          {snapshot.terms}
        </Typography>
      ) : null}
    </React.Fragment>
  )
}
